var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectronicArtsLogowine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-149.70195 -249.50625 1297.4169 1497.0375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499.006 0C223.852 0 0 223.855 0 499.014s223.852 499.011 499.006 499.011c275.156 0 499.007-223.852 499.007-499.011C998.014 223.855 774.162 0 499.006 0zm0 933.393c-239.516 0-434.374-194.862-434.374-434.379 0-239.52 194.858-434.381 434.374-434.381 239.513 0 434.375 194.862 434.375 434.381 0 239.516-194.861 434.379-434.375 434.379zm169.533-579.932h3.938v-19.076h7.098v-3.368h-18.117v3.368h7.082v19.076zm17.318-17.342h.072l6.225 17.342h3.207l6.223-17.342h.088v17.342h3.699v-22.443h-5.436l-6.016 17.554h-.104l-6.162-17.554h-5.525v22.443h3.729zm-113.33-5.12H327.041l-37.247 59.858h245.204zm50.168.571L472.624 570.533H306.16l38.405-59.909h99.771l38.112-59.88H251.794l-38.104 59.88h54.641l-75.812 119.611h316.389l116.86-184.295 42.609 64.684h-38.42l-36.385 59.909h113.773l39.506 59.702h72.576z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicArtsLogowine);
export default __webpack_public_path__ + "static/media/Electronic_Arts-Logo.wine.60454325949288897d6e177123edc579.svg";
export { ForwardRef as ReactComponent };